import { Directive, inject, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { AuthService, UserRole } from "./auth.service";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
    selector: '[appHasRole]',
    standalone: true
})
export class HasRoleDirective {
    private templateRef = inject(TemplateRef);
    private viewContainer = inject(ViewContainerRef);
    private authService = inject(AuthService);

    private requiredRole?: UserRole;

    @Input() set appHasRole(role: UserRole) {
        this.requiredRole = role;
        this.updateView();
    }

    constructor() {
        this.authService.roles$.pipe(takeUntilDestroyed()).subscribe(() => {
            this.updateView();
        })
    }

    private updateView() {
    this.viewContainer.clear();
    if (this.requiredRole && this.authService.hasRoleOrHigher(this.requiredRole)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}